const lessonsData = [
  {
    title: "Create Characters Table",
    description: "Maak een tabel Characters met id, name, species en first_appearance.",
    code: `CREATE TABLE Characters (
  id INT PRIMARY KEY,
  name VARCHAR(50),
  species VARCHAR(50),
  first_appearance DATE
);`
  },
  {
    title: "Insert Sample Data",
    description: "Voeg Mario en Luigi toe aan de Characters tabel.",
    code: `INSERT INTO Characters VALUES (1, 'Mario', 'Human', '1985-09-13');
INSERT INTO Characters VALUES (2, 'Luigi', 'Human', '1985-09-13');`
  }
];

export default lessonsData;